import { DecisionRespondent, type DecisionRespondentView } from '@apm/contracts';

/**
 * Người ngoài trả lời qua link công khai — APM-DSX-b, plan §11.3.
 *
 * Chưa đăng nhập thì phải khai tên + email trước khi chọn; trình duyệt nhớ lại
 * để lần sau (hay link sổ khác) khỏi gõ lại. Đây là tiện ích **của một người
 * xem** — đúng loại dữ liệu `localStorage` được phép giữ (CLAUDE.md): mất đi thì
 * người ta gõ lại, không hỏng gì.
 */
export const RESPONDENT_STORAGE_KEY = 'apm.decision-respondent';

/** `null` khi thiếu hoặc sai — cùng schema server dùng (`trim` trước `min`). */
export function parseRespondent(name: string, email: string): DecisionRespondent | null {
  const parsed = DecisionRespondent.safeParse({ name, email });
  return parsed.success ? parsed.data : null;
}

/**
 * Đọc lại người trả lời đã nhớ. Bọc try/catch: chế độ riêng tư, dữ liệu trang bị
 * chặn hay JSON hỏng đều chỉ có nghĩa là "chưa nhớ ai".
 */
export function loadRespondent(): { name: string; email: string } {
  try {
    const raw = window.localStorage.getItem(RESPONDENT_STORAGE_KEY);
    if (!raw) return { name: '', email: '' };
    const value = JSON.parse(raw) as Partial<Record<'name' | 'email', unknown>>;
    return {
      name: typeof value.name === 'string' ? value.name : '',
      email: typeof value.email === 'string' ? value.email : '',
    };
  } catch {
    return { name: '', email: '' };
  }
}

export function saveRespondent(respondent: DecisionRespondent): void {
  try {
    window.localStorage.setItem(RESPONDENT_STORAGE_KEY, JSON.stringify(respondent));
  } catch {
    // Không lưu được thì lần sau gõ lại — không phải lỗi của người dùng.
  }
}

/** "Nguyễn A · a@x.com" — email trống (trang công khai giấu đi) thì chỉ tên. */
export function respondentLabel(
  respondent: Pick<DecisionRespondentView, 'name' | 'email'>,
): string {
  return respondent.email ? `${respondent.name} · ${respondent.email}` : respondent.name;
}
